export interface ModalPosition {
  /** Override the modal's top position */
  top?: string;
  /** Override the modal's bottom position */
  bottom?: string;
  /** Override the modal's left position */
  left?: string;
  /** Override the modal's right position */
  right?: string;
}
export class ModalConfig<T = any> {
  /** Data being injected into the modal component */
  data?: T;
  /** Width of the modal */
  width? = '';
  /** Height of the modal */
  height? = '';
  /** Min-width of the modal */
  minWidth? = '';
  /** Min-height of the modal */
  minHeight? = '';
  /** Max-width of the modal */
  maxWidth? = '80vw';
  /** Max-height of the modal */
  maxHeight? = '';
  /** Position overrides */
  position?: ModalPosition;
  /** Prevent the user from closing the modal with esc or clicking the backdrop */
  disableClose? = false;
}

export type ModalSize = 'xl' | 'lg' | 'sm';
